import { Injectable } from '@angular/core';
import { EstensaPatientFolderService } from './angularjs/estensa-patient-folder.service';
import { RadioEprEvent } from 'estensa-module';
import { ServerRootService } from '../utils/routing/serverroot.service';
import { AuthData } from '@se/models';

@Injectable({
    providedIn: 'root',
})
export class PatientHistoryService extends ServerRootService {
    constructor(private patientFolderService: EstensaPatientFolderService) {
        super();
    }

    getAllEprEvents(patientId: string, AllBUSearch: boolean, credentials?: AuthData) {
        return this.patientFolderService.getPatientReportsNg2(patientId, AllBUSearch,credentials,false);
    }

}

export interface IEprEventsWithErrorMessage {
    displayMessage: string;
    exceptionMessage: string;
    eprEvents: RadioEprEvent[];
}
